var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BnOffsetCard',{attrs:{"blockTitle":_vm.titleExtra + ' egyéb adatok'}},[_c('div',{attrs:{"slot":"block-elements"},slot:"block-elements"},[_vm._t("biztositoi-adatok")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }